import { render, staticRenderFns } from "./publicSetting.vue?vue&type=template&id=657e7d23&scoped=true"
import script from "./publicSetting.vue?vue&type=script&lang=js"
export * from "./publicSetting.vue?vue&type=script&lang=js"
import style0 from "./publicSetting.vue?vue&type=style&index=0&id=657e7d23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657e7d23",
  null
  
)

export default component.exports